import Vue from "vue";
import App from "./App.vue";
import router from "@/router/index.js";
import "@/assets/scss/index.scss";
import { SExtraFilter } from "../stempcore/src/core/sextra";
import { SkFieldsComponents } from "../stempcore/src/core/sfield";
import VueWechatTitle from "vue-wechat-title";
import { common } from "@/model/common";
import authService from "@/services/authService";
import { ck } from "fire-wind-water";
import { saveChannelParams } from "../stempcore/src/sbase";
import VueCountryIntl from "../stempcore/src/lib/_vue-country-intl@1.1.9@vue-country-intl/lib/vue-country-intl.min";
import "../stempcore/src/lib/_vue-country-intl@1.1.9@vue-country-intl/lib/vue-country-intl.css";

saveChannelParams();
Vue.config.productionTip = false;
Vue.use(SkFieldsComponents).use(SExtraFilter).use(VueWechatTitle);
Vue.component(VueCountryIntl.name, VueCountryIntl);
Vue.mixin({
  methods: {
    pxOrVw(value) {
      let newValue;
      if (common.isMobile) {
        if (value > 2) {
          newValue = value / 7.5 + "vw";
        } else {
          newValue = "1px";
        }
      } else {
        newValue = value + "px";
      }
      return newValue;
    },
  },
});
window.$sk.Text.prototype.sendCode = function (key, o) {
  this.dirty = true;
  if (this.invalid) {
    return;
  }
  this.sendCodeJson.time = 60;
  this.sendCodeJson.disabled = true;
  this.sendCallback(this);
  authService
    .sendCheckCode({
      globalUserId: ck.cookie("globalUserId"),
      unique: this.areaCode ? this.areaCode + this.value : this.value,
      memberSchemaId: common.schemaId,
      action: "register",
      ...o,
    })
    .then((res) => {
      if (res.result !== 0) {
        window.$sk.alert(res.desc);
        this.sendCodeJson.time = 0;
        this.sendCodeJson.disabled = false;
        this.sendCallback(this);
      } else {
        this.sendWaiting();
      }
    });
};
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
